export default "__VITE_ASSET__DBXtiQsn__"